import React, { useContext, useState, useEffect, useMemo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress'
import WarningIcon from '@mui/icons-material/Warning';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  bgcolor: 'background.paper',
  borderRadius: 4,
  boxShadow: 24,
  p: 3,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const ChangeProjectTitleModal = ({ 
  openChangeProjectTitleModal, 
  setOpenChangeProjectTitleModal, 
  onConfirm,
  isLoading,
  setIsLoading,
  projectExists,
  setProjectExists
}) => {

  const [newProjectTitle, setNewProjectTitle] = useState('');

  useEffect(()=>{
    setNewProjectTitle('')
  },[openChangeProjectTitleModal])

  const handleConfirm = () => {
    onConfirm(newProjectTitle)
  };

  const handleClose = () => {
    setNewProjectTitle('')
    setProjectExists(false)
    setIsLoading(false)
    setOpenChangeProjectTitleModal(false)
  }

  const handleInputChange = (event) => {
    setProjectExists(false)
    setNewProjectTitle(event.target.value);
  };

  return (
    <Modal
      open={openChangeProjectTitleModal}
      onClose={handleClose}
      aria-labelledby="project-title-exists-modal-title"
      aria-describedby="project-title-exists-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="project-title-exists-modal-title"
          variant="h6"
          component="h2"
          sx={{ fontWeight: 'bold', mb: 2 }}
        >
          Project Title Already Exists
        </Typography>


        <Typography
          id="project-title-exists-modal-description"
          sx={{ textAlign: 'center', mb: 2 }}
        >
          A project with this title already exists. Please enter a new project title below.
        </Typography>

        <TextField
          fullWidth
          variant="outlined"
          label="New Project Title"
          value={newProjectTitle}
          onChange={handleInputChange}
          error={projectExists}
          sx={{ mb: 0 }}
        />

        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between'}}>
                { projectExists ? <Typography
                                      id="project-title-exists-modal-description"
                                      sx={{ color: 'red',textAlign: 'left'}}
                                    >
                                      *A project with this title already exists 
                                    </Typography> : <></> }
        </Box>

        <Box sx={{ display: 'flex', gap: 2, width: '100%', justifyContent: 'space-between',mt:3 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            disabled={!newProjectTitle || isLoading}
            style={{
                width: "50%"
            }}
          >
            {isLoading ? <div>Loading... <CircularProgress size={14} color="inherit" /></div>: 'Confirm'}
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClose}
            style={{
                width: "50%"
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ChangeProjectTitleModal;
